import { DropTarget } from 'react-dnd';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import DnDItemTypes from '../common/DynamicDnD/DnDItemTypes';
import DraggableTableRow from './DraggableTableRow';

const dropTarget = {
  drop(props, monitor) {
    props.handleDrop(monitor.getItem().draggedIndex, props.itemIndex);
  },
};

function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop(),
  };
}

class DroppableTableRow extends Component {
  render() {
    const {
      connectDropTarget,
      isOver,
      canDrop,
      itemIndex,
      label,
      value,
    } = this.props;

    return connectDropTarget(
      <div
        className={
          canDrop && isOver
            ? 'droppable table-tr clearfix'
            : 'table-tr clearfix'
        }
      >
        <DraggableTableRow itemIndex={itemIndex} label={label} value={value} />
      </div>
    );
  }
}

DroppableTableRow.propTypes = {
  connectDropTarget: PropTypes.func,
  isOver: PropTypes.bool,
  canDrop: PropTypes.bool,
};

export default DropTarget(
  [DnDItemTypes.DnD_ITEM_TYPE_6],
  dropTarget,
  collect
)(DroppableTableRow);
